export const KVP_ISSUE_OPTIONS = [
  { value: "technical_error", label: "Technischer Fehler" },
  { value: "unclear_content", label: "Inhalt unklar" },
  { value: "data_incorrect", label: "Daten stimmen nicht" },
  { value: "something_missing", label: "Etwas fehlt" },
  { value: "improvement_suggestion", label: "Verbesserungsvorschlag" },
  { value: "change_request", label: "Aenderungswunsch" },
  { value: "other", label: "Sonstiges" },
];

export const KVP_IMPACT_OPTIONS = [
  { value: "blocking", label: "blockiert mich" },
  { value: "difficult", label: "erschwert die Nutzung" },
  { value: "hint", label: "nur Hinweis / Verbesserung" },
];

export const KVP_GOAL_OPTIONS = [
  { value: "yes", label: "Ja" },
  { value: "partly", label: "Teilweise" },
  { value: "no", label: "Nein" },
];

export const KVP_DATA_SCOPE_OPTIONS = [
  { value: "display", label: "Anzeige" },
  { value: "storage", label: "Speicherung" },
  { value: "both", label: "beides" },
];

export const KVP_FLOW_COMPLETED_OPTIONS = [
  { value: "yes", label: "Ja" },
  { value: "partly", label: "Teilweise" },
  { value: "no", label: "Nein" },
];

export const KVP_IMPROVEMENT_FOCUS_OPTIONS = [
  { value: "clarity", label: "Verstaendlichkeit" },
  { value: "order", label: "Reihenfolge" },
  { value: "input", label: "Eingabe" },
  { value: "design", label: "Design" },
  { value: "speed", label: "Geschwindigkeit" },
  { value: "other", label: "Sonstiges" },
];

function detectDeviceType() {
  const width = typeof window !== "undefined" ? window.innerWidth : 0;
  const ua = typeof navigator !== "undefined" ? String(navigator.userAgent || "").toLowerCase() : "";
  if (/iphone|android.+mobile|mobile/.test(ua) || (width && width < 768)) return "mobile";
  if (/ipad|tablet|android/.test(ua) || (width && width < 1100)) return "tablet";
  return "desktop";
}

export function createKvpCorrelationId() {
  return `kvp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function buildKvpClientContext(baseContext = {}) {
  const {
    module_key,
    module_label,
    tab_key,
    tab_label,
    section_key,
    section_label,
    field_key,
    field_label,
    record_type,
    record_id,
    record_label,
    route_path,
    last_error_code,
    correlation_id,
  } = baseContext;

  return {
    route_path:
      route_path ||
      (typeof window !== "undefined"
        ? `${window.location.pathname}${window.location.search || ""}`
        : "/"),
    module_key: module_key || "unknown",
    module_label: module_label || module_key || "Bereich",
    tab_key: tab_key || null,
    tab_label: tab_label || tab_key || null,
    section_key: section_key || null,
    section_label: section_label || section_key || null,
    field_key: field_key || null,
    field_label: field_label || field_key || null,
    record_type: record_type || null,
    record_id: record_id || null,
    record_label: record_label || null,
    channel: "web",
    locale:
      (typeof navigator !== "undefined" && navigator.language) ||
      "de-DE",
    environment:
      process.env.NODE_ENV ||
      (typeof window !== "undefined" ? window.location.hostname : "unknown"),
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    device_type: detectDeviceType(),
    last_error_code: last_error_code || null,
    correlation_id: correlation_id || createKvpCorrelationId(),
  };
}

export function buildKvpContextLines(context = {}) {
  return [
    { label: "Bereich", value: context.module_label || context.module_key || "Bereich" },
    { label: "Tab", value: context.tab_label || context.tab_key || null },
    { label: "Abschnitt", value: context.section_label || context.section_key || null },
    { label: "Eintrag", value: context.record_label || null },
    { label: "Route", value: context.route_path || null },
  ].filter((entry) => entry.value);
}
